import { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';

const ENABLED_LANGUAGES: LanguageRegionCode[] = [
  'en-US',
  'en-GB',
  'da-DK',
  'de-DE',
  'es-ES',
  'es-MX',
  'fr-FR',
  'it-IT',
  'nl-NL',
  'nb-NO',
  'pl-PL',
  'pt-BR',
  'pt-PT',
  'sv-SE'
];

export default ENABLED_LANGUAGES;
